import React, { useContext } from "react";
import { FaStar } from "react-icons/fa6";
import { FaRegStarHalfStroke } from "react-icons/fa6";
import { TiShoppingCart } from "react-icons/ti";
import { FaRegHeart, FaShare } from "react-icons/fa";
import { CartContext } from "../../Componinets/Context/CartContext";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

function ProdictInfo({ product }) {
  let { cartitem, addtoCart, addtofavorites, favorites, removefromfavorite } =
    useContext(CartContext);
  let isincart = cartitem.some((i) => i.id === product.id);
  let navigate = useNavigate();

  let handelAddtocart = () => {
    addtoCart(product);

    toast.success(
      <div className="toast_werpper">
        <img src={product.images[0]} alt="" className="toast-img"></img>

        <div className="toast_content">
          <strong>{product.title}</strong>
          Added To Cart
          <div>
            <button onClick={() => navigate("/Cart")} className="btn">
              View Cart
            </button>
          </div>
        </div>
      </div>,
      { duration: 3500 }
    );
  };

  // favorites
  let isInfav = favorites.some((i) => i.id === product.id);
  let handltofav = () => {
    console.log(isInfav);
    if (isInfav) {
      removefromfavorite(product.id);
      toast.error(`${product.title} remove from Favorites`);
    } else {
      addtofavorites(product);
      toast.success(`${product.title} Added To Favorites`);
    }
  };

  return (
    <div className="Detailes_item">
      <h1 className="name">{product.title}</h1>
      <div className="stars">
        <FaStar />
        <FaStar />
        <FaStar />
        <FaStar />
        <FaRegStarHalfStroke />
      </div>
      <p className="price">${product.price}</p>
      <h5>
        Avilability:<span>{product.availabilityStatus}</span>
      </h5>
      <h5>
        Brand:<span>{product.brand}</span>
      </h5>
      <p className="desc">{product.description}</p>
      <h5 className="stock">
        <span>Hurry Up! Only{product.stock}Productes left in Stok</span>
      </h5>

      <button
        onClick={handelAddtocart}
        className={`btn ${isincart ? "in-cart" : ""}`}
      >
        {isincart ? "item in Cart" : "Add to Cart"}
        <TiShoppingCart />
      </button>

      <div className="icons">
        <span className={`${isInfav ? "In-fav" : ""}`} onClick={handltofav}>
          <FaRegHeart />
        </span>
        <span>
          <FaShare />
        </span>
      </div>
    </div>
  );
}

export default ProdictInfo;
